import { Fragment, PropsWithChildren, useEffect } from 'react';
import Cookies from 'js-cookie';

import { AppLoader } from '@/components';
import { useUserQuery } from '@/features/users';
import { removeAuthToken } from '@/features/auth';

const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp < now;
  } catch {
    return true;
  }
};

const AuthProvider = ({ children }: PropsWithChildren) => {
  const { data: user, isLoading } = useUserQuery();
  const path = window.location.pathname;

  const isPublicAuthPage = [
    '/admin/login',
    '/admin/forgot-password',
    '/admin/reset-password',
    '/admin/otp',
  ].some((p) => path.startsWith(p));

  useEffect(() => {
    const token = Cookies.get('access_token');

    if (!token || isTokenExpired(token)) {
      if (!isPublicAuthPage) {
        window.location.href = '/admin/login';
      }
    }

    if (user && isPublicAuthPage) {
      window.location.href = '/admin/dashboard';
    }
  }, [user, path]);

  if (isLoading) return <AppLoader />;

  return <Fragment>{children}</Fragment>;
};

export default AuthProvider;
